/* eslint-disable-next-line */
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import { Tab } from '@employ-engage/data';
import { useTranslation } from 'react-i18next';

export interface TabsProps {
  tabs: Tab[];
  className?: string;
}

export function Tabs({ tabs, className }: TabsProps) {
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);
  const currentTab = tabs.find((tab) => tab.current);
  return (
    <div className={className}>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          {t('Select a tab')}
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-light-secondaryAccent focus:ring-light-secondaryAccent"
          defaultValue={currentTab?.name}
          onChange={(event) => {
            if (currentTab?.to) {
              navigate(currentTab?.to);
            }
          }}
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex" aria-label="Tabs">
            {tabs.map((tab) => {
              if (tab.to) {
                return (
                  <Link
                    key={tab.name}
                    to={tab?.to}
                    className={classNames(
                      tab.current
                        ? 'border-light-secondaryAccent text-light-secondaryAccent'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                      'w-1/4 border-b-2 py-4 px-1 text-center text-sm font-medium'
                    )}
                    aria-current={tab.current ? 'page' : undefined}
                  >
                    {tab.name}
                  </Link>
                );
              } else if (tab.onClick) {
                return (
                  <button
                    key={tab.name}
                    onClick={tab?.onClick}
                    className={classNames(
                      tab.current
                        ? 'border-light-secondaryAccent text-light-secondaryAccent'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                      'w-1/4 border-b-2 py-4 px-1 text-center text-sm font-medium'
                    )}
                    aria-current={tab.current ? 'page' : undefined}
                  >
                    {tab.name}
                  </button>
                );
              }
              // A tab with neither a link nor a handler renders nothing.
              return null;
            })}
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Tabs;
